export enum RoleTypeFilter {
    COMPANY = '2001',
    GROUP = '2002',
    VEHICLE = '2003'
  }